
import React, { useEffect, useState } from 'react';
import { useForm } from '../../../context/FormContext';
import FormPage from '../FormPage';
import FormCompleted from '../FormCompleted';

const FormPageContent: React.FC = () => {
  const { currentPage, isSubmitted, formData } = useForm();
  const [hasWorksheets, setHasWorksheets] = useState(false);
  const [documentUrls, setDocumentUrls] = useState<string[]>([]);
  
  // Check if there are available worksheets
  useEffect(() => {
    if (formData.subject_data) {
      try {
        const worksheetData = typeof formData.subject_data === 'string' 
          ? JSON.parse(formData.subject_data as string) 
          : formData.subject_data;
          
        if (worksheetData && 
            worksheetData.document_urls && 
            Array.isArray(worksheetData.document_urls) &&
            worksheetData.document_urls.length > 0) {
          
          setHasWorksheets(true);
          setDocumentUrls(worksheetData.document_urls);
        } else {
          setHasWorksheets(false);
          setDocumentUrls([]);
        }
      } catch (error) {
        console.error("Error parsing worksheet data:", error);
        setHasWorksheets(false);
        setDocumentUrls([]);
      }
    } else {
      setHasWorksheets(false);
      setDocumentUrls([]);
    }
  }, [formData.subject_data]);
  
  // Show completion page if form is successfully submitted
  if (isSubmitted) {
    return <FormCompleted />;
  }
  
  return (
    <FormPage 
      pageNumber={currentPage} 
      hasWorksheets={hasWorksheets} 
      documentUrls={documentUrls}
    />
  );
};

export default FormPageContent;
